<div [innerHTML]="templateString | safeHtml: 'html'" class="template-container" [class.show]="show"></div>
<button *ngIf="isShowVisible" class="row ml-0 btn btn-link p-0 show-hide-button" (click)="show = !show">
    {{ show ? 'Show' : 'Hide' }}
    <fa-icon [icon]="show ? 'chevron-down' : 'chevron-up'"></fa-icon>
</button>
